var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Review sourse",
    clipPath: "url(#clip0_190_2801)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.6 19.9C3.85 19.05 0.25 14.95 0.25 10C0.25 4.5 4.75 0 10.25 0C15.75 0 20.25 4.5 20.25 10C20.25 14.95 16.65 19.05 11.9 19.9L11.35 19.45H9.15L8.6 19.9Z",
    fill: "url(#paint0_linear_190_2801)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.15 12.8L14.6 10H11.95V8.05002C11.95 7.25002 12.25 6.65002 13.45 6.65002H14.75V4.10002C14.05 4.00002 13.25 3.90002 12.55 3.90002C10.25 3.90002 8.65002 5.30002 8.65002 7.80002V10H6.15002V12.8H8.65002V19.85C9.20002 19.95 9.75002 20 10.3 20C10.85 20 11.4 19.95 11.95 19.85V12.8H14.15Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_190_2801",
    x1: 10.2505,
    y1: 19.3045,
    x2: 10.2505,
    y2: -0.00368389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0062E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19AFFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_190_2801"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.3cf097521850e8ec44b295b431fea965.svg";
export { ForwardRef as ReactComponent };